import TableLoading from "./TableLoading";

export default TableLoading;
